module.exports = __webpack_public_path__ + "static/img/gongzhong.d20a329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongzhong.jpg
// module id = 1453
// module chunks = 3